module.exports = __webpack_public_path__ + "img/route-save.6e38e3fd.svg";